// Components
const ToastNotification = () => import(/* webpackPrefetch: true, webpackChunkName: "toast-notification" */ '@/app/views/main-view/_shared/_utilities/toast-notification/toast-notification.vue');

// Event Bus
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'App',
	components: {
		ToastNotification
	},
	data() {
		return {
			isAppFixed: false
		}
	},
	computed: {
		showSideBar() {
			return this.$store.getters.getSideBar;
		}
	},
	created() {
		EventBus.$on('makeRootAppFixed', isAppFixed => {
			this.isAppFixed = isAppFixed;
		});
	}
}